import { EmberRoute } from '../../../../../enums/emberRoute'
import { NavigationMenuItem } from '../types/NavigationMenuItem'

export const removeInvalidMenuItems = (items: NavigationMenuItem[]): NavigationMenuItem[] =>
  items.filter((item) => {
    if (typeof item.to !== 'string') {
      return true
    }

    const hasUndefinedSegment = item.to.split('/').includes('undefined')
    const isBankRoute = item.to === EmberRoute.Bank || item.to === EmberRoute.BankReact

    return !(hasUndefinedSegment && isBankRoute)
  })
